import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-info-tooltip',
  template: `
    @if (tooltip) {
      <button
        type="button"
        class="w-4 h-4 inline-flex items-center justify-center rounded-full translate-y-0.5"
        [matTooltip]="tooltip"
        matTooltipPosition="above"
        data-cy="tooltip-info-button">
        <mat-icon class="w-3 h-3 text-base">help</mat-icon>
      </button>
    }
  `,
  imports: [MatIcon, MatTooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoTooltipComponent {
  @Input() tooltip: string;
}
